(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('iis-cart-delivery')) {
    class IisCartDelivery extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.loadDelivery();
      }

      async loadDelivery() {
        const rows = Array.from(this.querySelectorAll('[data-iis-delivery-item]'));
        const pending = rows.slice();
        const requests = new Map();
        const previewId = new URL(location.href).searchParams.get('preview_theme_id');
        const worker = async () => {
          while (pending.length) {
            const row = pending.shift();
            try {
              const origin = new URL(document.baseURI).origin;
              const url = new URL(row.dataset.productUrl, origin);
              if (url.origin !== origin) throw new Error('Unexpected product origin');
              if (previewId) url.searchParams.set('preview_theme_id', previewId);
              if (!requests.has(url.href)) requests.set(url.href, this.readDelivery(url));
              const texts = await requests.get(url.href);
              if (!this.isConnected) return;
              if (!texts.length) {
                row.hidden = true;
                row.dataset.deliveryState = 'empty';
                continue;
              }
              row.deliveryTexts = texts;
              row.dataset.deliveryState = 'ready';
            } catch {
              row.dataset.deliveryState = 'unavailable';
            }
          }
        };
        await Promise.all(Array.from({ length: Math.min(3, rows.length) }, worker));
        if (!this.isConnected) return;
        this.renderGroups(rows);
        this.hidden = !rows.some(row => row.dataset.deliveryState !== 'empty');
        this.querySelector('[data-iis-delivery-service]').hidden = !rows.some(row => row.dataset.deliveryState === 'ready');
        this.querySelector('.iis-cart-delivery__list').setAttribute('aria-busy', 'false');
      }

      textKey(text) {
        return text.normalize('NFC').toLocaleLowerCase('de-DE').replace(/\u00a0/g, ' ').replace(/(\d)\s*[-–—]\s*(?=\d)/g, '$1–').replace(/\s+/g, ' ').trim();
      }

      noteDetails(text) {
        const normalized = this.textKey(text).replace(/[.!]$/, '').trim();
        const restock = normalized.match(/^bei bedarf werden zusätzliche mengen( oder farben)? für dich nachbestellt\s*\(\s*(lieferzeit\s+[^()]+?)\s*\)?$/);
        if (!restock) return { key:'text:' + this.textKey(text), text, priority:0 };
        let display = text.trim();
        if (!/\)[.!]?$/.test(display)) display = display.replace(/([.!]?)$/, ')$1');
        return { key:'restock:' + restock[2].trim(), text:display, priority:restock[1] ? 1 : 0 };
      }

      splitDelivery(texts) {
        const lines = texts[0].split('\n').map(line => line.trim()).filter(Boolean);
        if (/^lieferzeit(?:en)?\b[^:]*:/i.test(lines[0])) {
          return { heading:lines[0], notes:[...lines.slice(1), ...texts.slice(1)] };
        }
        return { heading:texts[0], notes:texts.slice(1) };
      }

      displayedDuration(text) {
        const match = text.match(/\b(\d+(?:[.,]\d+)?)\s*(?:[-–—]\s*(\d+(?:[.,]\d+)?)\s*)?(Werktag(?:e|en)?|Arbeitstag(?:e|en)?|Tag(?:e|en)?|Woche(?:n)?)\b/i);
        if (!match) return null;
        return { unit:match[3].toLowerCase().replace(/(?:en|e|n)$/, ''), end:Number((match[2] || match[1]).replace(',', '.')) };
      }

      renderGroups(rows) {
        const ready = rows.filter(row => row.dataset.deliveryState === 'ready');
        const profiles = new Map();
        for (const row of rows.filter(row => row.dataset.deliveryState !== 'empty')) {
          const key = JSON.stringify((row.deliveryTexts || [row.dataset.productUrl]).map(text => this.textKey(text)));
          if (!profiles.has(row.dataset.productId)) profiles.set(row.dataset.productId, new Set());
          profiles.get(row.dataset.productId).add(key);
        }
        const groups = new Map();
        for (const row of ready) {
          const delivery = this.splitDelivery(row.deliveryTexts);
          const key = this.textKey(delivery.heading).replace(/^lieferzeit(?:en)?(?: für das garn)?\s*:\s*/, '');
          if (!groups.has(key)) groups.set(key, { heading:delivery.heading, members:new Map(), notes:new Map(), duration:this.displayedDuration(delivery.heading) });
          const group = groups.get(key);
          const variant = row.querySelector('[data-iis-delivery-variant]');
          const distinguishVariant = profiles.get(row.dataset.productId).size > 1;
          const name = row.querySelector('.iis-cart-delivery__product').textContent.trim() + (distinguishVariant && variant ? ' – ' + variant.textContent.trim() : '');
          const memberKey = JSON.stringify([row.dataset.productId, distinguishVariant ? row.dataset.productUrl : '']);
          group.members.set(memberKey, name);
          for (const text of delivery.notes) {
            const note = this.noteDetails(text);
            const existing = group.notes.get(note.key);
            if (!existing || note.priority > existing.priority) group.notes.set(note.key, note);
          }
        }
        const ordered = Array.from(groups.values());
        const units = new Set(ordered.filter(group => group.duration).map(group => group.duration.unit));
        for (const unit of units) {
          const positions = ordered.flatMap((group, index) => group.duration?.unit === unit ? [index] : []);
          const sorted = positions.map(index => ordered[index]).sort((a, b) => a.duration.end - b.duration.end);
          positions.forEach((position, index) => { ordered[position] = sorted[index]; });
        }
        const showProducts = ordered.length > 1 || rows.some(row => row.dataset.deliveryState !== 'ready');
        const elements = ordered.map(group => {
          const item = document.createElement('li');
          item.className = 'iis-cart-delivery__item';
          const heading = document.createElement('p');
          heading.className = 'iis-cart-delivery__heading';
          heading.textContent = group.heading.replace(/^lieferzeit(?:en)?(?: für das garn)?\s*:\s*/i, '');
          item.append(heading);
          if (showProducts) {
            const products = document.createElement('p');
            products.className = 'iis-cart-delivery__products';
            products.textContent = Array.from(group.members.values()).join(' · ');
            item.append(products);
          }
          for (const note of group.notes.values()) {
            const paragraph = document.createElement('p');
            paragraph.className = 'iis-cart-delivery__notes';
            paragraph.textContent = note.text;
            item.append(paragraph);
          }
          return item;
        });
        const unavailable = rows.filter(row => row.dataset.deliveryState === 'unavailable');
        this.querySelector('.iis-cart-delivery__list').replaceChildren(...elements, ...unavailable);
      }

      async readDelivery(url) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(url.href, { credentials:'same-origin', signal:controller.signal });
          if (!response.ok) throw new Error('Product page unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const directSelector = '.yarn-prototype__delivery, .iis-garn__delivery';
          const blocks = page.querySelectorAll(directSelector + ', .shopify-section--main-product .product-info__block-item[data-block-type="text"], .shopify-section--main-product .product-info__block-item[data-block-type="liquid"]');
          if (!blocks.length && !page.querySelector('meta[property="og:type"][content="product"]')) throw new Error('Product template unavailable');
          const texts = [];
          for (const block of blocks) {
            if (block.closest('[hidden], [aria-hidden="true"]')) continue;
            const content = block.cloneNode(true);
            content.querySelectorAll('script, style, template, noscript, [hidden], [aria-hidden="true"]').forEach(node => node.remove());
            content.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
            content.querySelectorAll('p, li, div, h1, h2, h3, h4, h5, h6').forEach(node => node.append('\n'));
            const text = content.textContent.replace(/[ \t]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n').trim();
            if (text && (block.matches(directSelector) || /\blieferzeit(?:en)?\b/i.test(text)) && !texts.includes(text)) texts.push(text);
          }
          return texts;
        } finally {
          clearTimeout(timeout);
        }
      }
    }
    customElements.define('iis-cart-delivery', IisCartDelivery);
  }

  } catch(e) { console.error(e); }
})();
})();
